export class LabelAngleConfig {
}
LabelAngleConfig.color = 0xFF4DDD;
//# sourceMappingURL=LabelAngleConfig.js.map